import { takeLatest, put } from 'redux-saga/effects';
import { appNotify, adminSwitchMaintenanceMode } from 'store/actions';
import { postWithToken } from 'api/network';

export function* maintenanceSaga() {
    yield takeLatest(adminSwitchMaintenanceMode, function* ({ payload }) {
      try {
        console.log(`adminSwitchMaintenanceMode triggered with request = ${payload}`);
        yield postWithToken(`/api/admin/maintenance/${payload}`);
      } catch (error) {
        console.log(error.message);
        yield put(appNotify(`Failed to change maintenance mode: ${error.message}`, 'error'));
      }
    });
  }